export default "__VITE_ASSET__BpWCopun__"